/** Hero image on article page (Figma 1289 x 333). */
export const ARTICLE_HERO_IMAGE_ASPECT = 1289 / 333;

/** In-article content images: full-width landscape in body column. */
export const ARTICLE_BODY_IMAGE_ASPECT = 16 / 9;

export const ARTICLE_IMAGE_MAX_BYTES = 2 * 1024 * 1024;

export const formatAspectRatioLabel = (aspect) => {
  if (Math.abs(aspect - ARTICLE_HERO_IMAGE_ASPECT) < 0.01) {
    return "1289:333";
  }
  if (Math.abs(aspect - ARTICLE_BODY_IMAGE_ASPECT) < 0.01) {
    return "16:9";
  }
  return aspect.toFixed(2);
};
